import React, { useState } from "react";
import { connect } from "react-redux";
// import SingleProductForm from "./SingpleProductForm";
// import VariableProductForm from "./VariableProductForm";
// import Addproduct from "./Addproduct";

import { Layout, Breadcrumb, Row, Col, Select, Divider } from "antd";

const AddProduct = () => {
//   const [updatelist, setUpdatelist] = useState(true);
//   const [producttype, setproducttype] = useState("S");

  function handleChange(value) {
    // setproducttype(value);
  }
  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Wholesale</Breadcrumb.Item>
        <Breadcrumb.Item>Add</Breadcrumb.Item>
      </Breadcrumb>

      <div className="site-layout-background main-frame">
        index
        {/* <Addproduct setUpdatelist={setUpdatelist} updatelist={updatelist} /> */}
      </div>
    </>
  );
};

export default connect()(AddProduct);
